export var getShowCurrentVoteStage = function (voteCollectionData, currentStageIdx, blockNum, isEditable) {
    var _a;
    return ((voteCollectionData === null || voteCollectionData === void 0 ? void 0 : voteCollectionData.stage) &&
        !!((_a = voteCollectionData === null || voteCollectionData === void 0 ? void 0 : voteCollectionData.voteCollection) === null || _a === void 0 ? void 0 : _a.length) &&
        currentStageIdx === blockNum &&
        !isEditable);
};
//# sourceMappingURL=getShowCurrentVoteStage.js.mapexport var getShowCurrentVoteStage = function (voteCollectionData, currentStageIdx, blockNum, isEditable) {
    var _a;
    return ((voteCollectionData === null || voteCollectionData === void 0 ? void 0 : voteCollectionData.stage) &&
        !!((_a = voteCollectionData === null || voteCollectionData === void 0 ? void 0 : voteCollectionData.voteCollection) === null || _a === void 0 ? void 0 : _a.length) &&
        currentStageIdx === blockNum &&
        !isEditable);
};
//# sourceMappingURL=getShowCurrentVoteStage.js.map